import {
  Box,
  Skeleton,
  Alert,
  AlertIcon,
  AlertDescription,
} from '@chakra-ui/react';
import React from 'react';
import { useHistory } from 'react-router-dom';

import { utils as commonUtils } from '@finley-technologies/common';

import { useGenerateExploApiTokenQuery } from '../requests/explo.gql.generated';

export const ExploDashboardContainer: React.FC<{
  organizationId: string;
  creditFacilityId: string;
}> = ({ creditFacilityId, organizationId }) => {
  const history = useHistory();

  const { data: tokenData } = useGenerateExploApiTokenQuery({
    fetchPolicy: 'network-only',
    variables: { organizationId, creditFacilityId, embedType: 'dashboard' },
    onError: (_err) => {
      history.push('/');
    },
  });

  if (!tokenData) {
    return <Skeleton />;
  }

  // TODO: temporary management of not having Explo set up yet for facility.
  // Can embellish this experience once we have a better data model around
  // what customers has Explo set up and their viewing access
  if (!tokenData.tokenResponse.succeeded) {
    return (
      <Alert status="info">
        <AlertIcon />
        <AlertDescription>
          Strats has not been set up for this credit facility. Contact your
          Customer Sales Manager to explore additional features.
        </AlertDescription>
      </Alert>
    );
  }

  return (
    <Box id="explo-dashboard-container">
      <explo-dashboard
        dash-jwt={tokenData.tokenResponse.jwt}
        refresh-minutes={5}
        environment={commonUtils.EnvUtils.getEnv()}
        updateUrlParams
      />
    </Box>
  );
};
